import { ButtonWidth } from '../Button'

export const getLayerSpacing = (buttonWidth: ButtonWidth) => buttonWidth * 0.15
